module.exports = __webpack_public_path__ + "static/img/newHuaiC5.3d730d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC5.png
// module id = 4N3l
// module chunks = 0